import { templateAPI } from '@/utils/api';

/**
 * 确保模板带有可用的 slideCanvases（外置存储时从旁路表拉取全量）。
 * 设计器打开走按页加载；POD/合成等批量路径需要全量画布。
 */
export async function hydrateTemplateCanvases(template) {
  if (!template || typeof template !== 'object') return template;
  const td = template.templateData && typeof template.templateData === 'object'
    ? { ...template.templateData }
    : {};
  const embedded = td.slideCanvases && typeof td.slideCanvases === 'object'
    ? td.slideCanvases
    : {};
  const isExternal = td.canvasStorage === 'external'
    || (Array.isArray(td.slideCanvasIds) && td.slideCanvasIds.length > 0 && Object.keys(embedded).length < td.slideCanvasIds.length);

  if (!isExternal) {
    return template;
  }

  const ids = Array.isArray(td.slideCanvasIds) ? td.slideCanvasIds : Object.keys(embedded);
  const complete = ids.length > 0 && ids.every((id) => {
    const canvas = embedded[id];
    return canvas && !canvas._externalPending && Array.isArray(canvas.objects);
  });
  if (complete) {
    return template;
  }

  try {
    const canvases = await templateAPI.getSlideCanvases(template.id);
    if (canvases && Object.keys(canvases).length > 0) {
      td.slideCanvases = canvases;
      td.canvasStorage = 'external';
      td.slideCanvasIds = Object.keys(canvases);
      const primary = td.primaryImageId || Object.keys(canvases)[0];
      if (primary && canvases[primary]) {
        td.fabricCanvas = canvases[primary];
        td.primaryImageId = primary;
      }
      return { ...template, templateData: td };
    }
  } catch (error) {
    console.warn('hydrateTemplateCanvases: getSlideCanvases failed', error);
  }

  try {
    const { template: full } = await templateAPI.getById(template.id, { fullSlides: true });
    if (full?.templateData) {
      return {
        ...template,
        ...full,
        templateData: {
          ...td,
          ...full.templateData,
        },
      };
    }
  } catch (error) {
    console.warn('hydrateTemplateCanvases: fullSlides fallback failed', error);
  }

  return template;
}
